<template>
    <div class="report-container">
         <form class="mb-3">
            <b-form-row>
                <b-form-group class="col-md-3" label="Fecha servicio desde *" >
                    <b-form-datepicker 
                        locale="es" 
                        :class="{'active-filter':filters.startDate}" 
                        reset-button size="sm" 
                        v-model="filters.startDate"/>
                </b-form-group>

                <b-form-group class="col-md-3" label="Hasta fecha de servicio *" >
                    <b-form-datepicker 
                        locale="es" 
                        :class="{'active-filter':filters.endDate}" 
                        reset-button  
                        size="sm" 
                        v-model="filters.endDate"/>
                </b-form-group>

                <b-form-group>
                    <b-button 
                        variant="warning" 
                        v-b-toggle="'advanced-filters'" 
                        class="btn mr-2 mt-4" 
                        id="advanced-filters">
                        <md-icon icon="filter_list"/>
                    </b-button>
                    <b-tooltip 
                        target="advanced-filters" 
                        triggers="hover">
                        Mostrar/Ocultar Filtros avanzados
                    </b-tooltip>
                    <b-button 
                        class="mt-4 mr-2"
                        variant="primary" 
                        type="button" 
                        @click="search()">
                        <md-icon icon="search"/>
                    </b-button>
                    <b-button
                        class="mt-4"
                        @click="excel()"
                        :disabled="loadingExcel"
                        variant="warning">
                        <b-spinner small v-if="loadingExcel" class="mr-1"></b-spinner>
                        {{ loadingExcel ? 'Exportando...' : 'Exportar XLS' }}
                    </b-button>
                </b-form-group>

            </b-form-row>

            <b-collapse id="advanced-filters">
                <b-form-row>
                    <b-form-group class="col-lg-4" label="Proveedor">
                        <multiselect
                        v-model="filters.suppliers"
                        :options="suppliersOpts"
                        group-label="group"
                        group-values="options"
                        group-select
                        multiple
                        label="text"
                        track-by="value"
                        placeholder="Todos"
                        taggable>
                        <template v-slot:clear >
                            <div class="multiselect__clear" @click="filters.suppliers = []">
                            </div>
                        </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-lg-4" label="Estado de servicio">
                        <multiselect
                        v-model="filters.status"
                        :options="statusOpts"
                        group-label="group"
                        group-values="options"
                        group-select
                        multiple
                        label="text"
                        track-by="value"
                        placeholder="Todos"
                        taggable>
                        <template v-slot:clear >
                            <div 
                            class="multiselect__clear" 
                            @click="filters.status = []">
                            </div>
                        </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-lg-4 mt-0" label="Canal de venta">
                        <multiselect
                        :class="{'active-filter':filters.salesChannels.length>0}"
                        v-model="filters.salesChannels"
                        :options="channelOpts"
                        multiple
                        label="text"
                        placeholder="Todos"
                        taggable
                        track-by="value">
                        <template v-slot:clear >
                            <div class="multiselect__clear" @click="filters.salesChannels = []">
                            </div>
                        </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-lg-6" label="Zonas Master">
                        <multiselect v-model="filters.zones"
                            :options="zonedAreasGroupedOpts"
                            :multiple="true"
                            group-values="zones"
                            group-label="zonedArea"
                            :group-select="true"
                            placeholder="Type to search"
                            track-by="text"
                            label="text">
                            <span slot="noResult">Oops! No se encontraron resultados.</span>
                            <template v-slot:clear >
                                <div class="multiselect__clear" @click="filters.zones = []"></div>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc" v-if="props.option.$groupLabel">
                                    <span class="option__title">{{ props.option.$groupLabel }}</span><br>
                                </div>
                                <div class="option__desc"  v-else>
                                    <span class="option__title">{{ props.option.text }}</span><br>
                                    <small class="option__small text-muted">
                                        {{ props.option.zonedAreaName }}
                                    </small>
                                </div>
                            </template>
                            <template slot="option-group" slot-scope="props">
                                <div class="option__desc">
                                    <span class="option__title">{{ props.option.text }}</span><br>
                                    <small class="option__small text-muted">
                                    {{ props.option.zonedAreaName }}
                                    </small>
                                </div>
                            </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group
                        class="col-lg-1"
                        label="Viaje">
                        <b-form-select
                            :class="{ 'active-filter': filters.trip }"
                            v-model="filters.trip"
                            :options="tripOpts"/>
                    </b-form-group>

                    <b-form-group
                        class="col-lg-2"
                        label="Conductor">
                        <b-form-select
                            :class="{ 'active-filter': filters.driverOpts }"
                            v-model="filters.withDriver"
                            :options="driverOpts"/>
                    </b-form-group>

                    <b-form-group
                        class="col-lg-2"
                        label="Agrupar tendencia">
                        <b-form-select
                            v-model="filters.timeGrouping"
                            :options="groupingOpts"/>
                    </b-form-group>

                </b-form-row>
            </b-collapse>
        </form>

        <!-- Tabs -->
        <b-tabs content-class="mt-3" v-model="tabActive">
            <b-tab title="Estadisticas" active>
                <b-overlay :show="loading">

                        <!-- Resumen General -->
                    <b-row class="mb-4" v-if="summary.general">
                        <b-col md="6">
                            <b-card>
                                <h5 class="text-center mb-3">Resumen General</h5>
                                <div class="d-flex justify-content-around text-center mb-3">
                                    <div>
                                        <h3 class="mb-0">{{ summary.totalRides || 0 }}</h3>
                                        <small class="text-muted">Total Rides</small>
                                    </div>
                                </div>
                                <chart :options="generalPieChartOptions" ref="generalPieChart"></chart>
                            </b-card>
                        </b-col>
                        <b-col md="6">
                            <b-card>
                                <h5 class="text-center mb-3">Distribución por Categoría</h5> 
                                <b-table
                                    small
                                    bordered
                                    :items="generalStatsTable"
                                    :fields="generalStatsFields">
                                    <template #cell(percentage)="data">
                                        <b-progress :max="100" height="20px">
                                            <b-progress-bar
                                                :value="data.item.percentage"
                                                :variant="data.item.variant">
                                                {{ data.item.percentage }}%
                                            </b-progress-bar>
                                        </b-progress>
                                    </template>
                                </b-table>
                            </b-card>
                        </b-col>
                    </b-row>

                    <!-- Gráfico por Tiempo (Líneas) -->
                    <b-row class="mb-4" v-if="summary.byTime && summary.byTime.data && summary.byTime.data.length > 0">
                        <b-col>
                            <b-card>
                                <h5 class="text-center mb-3">Tendencia por {{ summary.byTime.grouping === 'week' ? 'Semana' : 'Periodo' }}</h5>
                                <chart :options="timeLineChartOptions" ref="timeLineChart"></chart>
                            </b-card>
                        </b-col>
                    </b-row>

                    <!-- Gráfico por Proveedor -->
                    <b-row class="mb-4" v-if="summary.bySupplier && summary.bySupplier.length > 0">
                        <b-col>
                            <b-card>
                                <h5 class="text-center mb-3">Estadísticas por Proveedor</h5>
                                <chart :options="supplierChartOptions" ref="supplierChart"></chart>
                            </b-card>
                        </b-col>
                    </b-row>

                    <!-- Gráfico por Conductor (Mejores) -->
                    <b-row class="mb-4" v-if="summary.byDriver && summary.byDriver.length > 0">
                        <b-col>
                            <b-card>
                                <h5 class="text-center mb-3">Mejores Conductores por Volumen (Top 20)</h5>
                                <chart :options="driverChartOptions" ref="driverChart"></chart>
                            </b-card>
                        </b-col>
                    </b-row>

                    <!-- Gráfico por Conductor (Peores - Mayor No Chat + NC Driver) -->
                    <b-row class="mb-4" v-if="summary.byDriver && summary.byDriver.length > 0 && Object.keys(worstDriversChartOptions).length > 0">
                        <b-col>
                            <b-card>
                                <h5 class="text-center mb-3">Conductores con Mayor Índice de No Chat + NC Driver (Top 20)</h5>
                                <small class="text-muted d-block text-center mb-3">Solo conductores con 5+ rides</small>
                                <chart :options="worstDriversChartOptions" ref="worstDriverChart"></chart>
                            </b-card>
                        </b-col>
                    </b-row>

                    <div v-if="!summary.general" class="text-center text-muted py-5">
                        <p>Realiza una búsqueda para ver las estadísticas</p>
                    </div>


                </b-overlay>
            </b-tab>

            <b-tab title="Reporte">
                <!-- Loading -->
                <div v-if="loading" class="col-12 text-center pt-5">
                    <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
                    <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
                    <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
                </div>
                <!-- End Loading -->

                <div class="py-3" v-else>
                    <b-row>
                        <b-col class="mb-2">
                            <div class="mr-4">
                                <span>{{ rowsMessage }}</span>
                                <b-form-select
                                    size="sm"
                                    class="ml-2"
                                    id="perPageSelector"
                                    v-model="perPage"
                                    :options="perPageOptions"
                                    @change="updateTable"
                                ></b-form-select>
                            </div>
                        </b-col>
                        <b-col class="text-right">
                            <b-pagination
                                v-model="currentPage"
                                align="right"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                @input="onPageChange"
                            />
                        </b-col>
                    </b-row>

                    <b-table
                        id="spit-main-table"
                        show-empty
                        hover
                        small
                        bordered
                        stacked="lg"
                        :items="table.body" 
                        :fields="table.fields"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        responsive>

                        <!-- Columna de servicio -->
                        <template #cell(serviceNumber)="data">
                            <strong>{{ data.item.reservationId }}-{{ data.item.consecutiveId }}</strong>
                            <div class="text-muted small">ID: {{ data.item.id }}</div>
                        </template>

                        <!-- Columna de proveedor y canal -->
                        <template #cell(supplier)="data">
                            <div v-if="data.item.supplier">
                                <b-badge variant="primary" class="mr-1">{{ data.item.supplier.name }}</b-badge>
                            </div>
                            <div v-if="data.item.sales_channel" class="mt-1">
                                <b-badge variant="info">{{ data.item.sales_channel.name }}</b-badge>
                            </div>
                        </template>

                        <!-- Columna de fechas -->
                        <template #cell(pickupDatetime)="data">
                            <div class="text-nowrap">
                                <div><strong>Pickup:</strong> {{ data.item.pickupDatetime }}</div>
                                <div class="text-muted small"><strong>Vuelo:</strong> {{ data.item.flightDatetime }}</div>
                            </div>
                        </template>

                        <!-- Columna de lugares -->
                        <template #cell(pickup_place)="data">
                            <div v-if="data.item.pickup_place">
                                <b-badge v-if="data.item.pickup_place.isAirport" variant="warning" class="mr-1">
                                    <md-icon icon="flight" class="small"/>
                                </b-badge>
                                <span :class="{'text-primary': data.item.pickup_place.isAirport}">
                                    {{ data.item.pickup_place.name | truncate(40) }}
                                </span>
                            </div>
                        </template>

                        <template #cell(dropoff_place)="data">
                            <div v-if="data.item.dropoff_place">
                                <b-badge v-if="data.item.dropoff_place.isAirport" variant="warning" class="mr-1">
                                    <md-icon icon="flight" class="small"/>
                                </b-badge>
                                <span :class="{'text-primary': data.item.dropoff_place.isAirport}">
                                    {{ data.item.dropoff_place.name | truncate(40) }}
                                </span>
                            </div>
                        </template>

                        <!-- Columna de estado -->
                        <template #cell(status)="data">
                            <div>
                                <b-badge :variant="variantStatus[data.item.status]" class="text-uppercase">
                                    {{ statusLabels[data.item.status] || data.item.status }}
                                </b-badge>
                            </div>
                        </template>

                        <!-- Columna de conductor -->
                        <template #cell(user_driver)="data">
                            <span class="text-nowrap" v-if="data.item.user_driver">
                                <b-badge variant="success" class="mr-1" v-if="data.item.user_driver.tia">TIA</b-badge>
                                {{ data.item.user_driver.firstName }}
                                {{ data.item.user_driver.lastName }}
                            </span>
                            <span v-else class="text-muted">Sin asignar</span>
                        </template>

                        <!-- Columna de conductor -->
                        <template #cell(status_chat)="data">
                            <span class="text-nowrap" v-if="data.item.status_chat">                                
                                 <b-badge
                                    :key="data.item.status_chat.id"
                                    :variant="getTagVariant(data.item.status_chat.text)"
                                    class="mr-1 mb-1">
                                    {{ data.item.status_chat.text }}
                                </b-badge>
                            </span>
                            <span v-else class="text-muted">Sin asignar</span>
                        </template>

                        <!-- Columna de conductor -->
                        <template #cell(meet_and_greet)="data">
                            <span class="text-nowrap" v-if="data.item.meet_and_greet">                                
                                 <b-badge
                                    :key="data.item.meet_and_greet.id"
                                    :variant="getTagVariant(data.item.meet_and_greet.text)"
                                    class="mr-1 mb-1">
                                    {{ data.item.meet_and_greet.text }}
                                </b-badge>
                            </span>
                            <span v-else class="text-muted">Sin definir</span>
                        </template>

                        <!-- Columna de tags -->
                        <template #cell(tags)="data" v-if="false">
                            <div v-if="data.item.tags && data.item.tags.length > 0">
                                <b-badge
                                    v-for="tag in data.item.tags"
                                    :key="tag.id"
                                    :variant="getTagVariant(tag.text)"
                                    class="mr-1 mb-1">
                                    {{ tag.text }}
                                </b-badge>
                            </div>
                            <span v-else class="text-muted">-</span>
                        </template>
                    </b-table>
                </div>
            </b-tab>
        </b-tabs>

    </div>
</template>
<script>
import moment from 'moment'
import api from "../../../../api.js";
import Multiselect from 'vue-multiselect';
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
exportingInit(Highcharts)

export default {
    name: "driver-chat",
    components: {Multiselect, Chart},
    filters: {
        truncate(value, length) {
            if (!value) return '';
            if (value.length <= length) return value;
            return value.substring(0, length) + '...';
        }
    },
    data() {
        
        let start = moment().startOf('month').format('YYYY-MM-DD');
        let end   = moment().format('YYYY-MM-DD');

        return {
			loading: false,
			loadingExcel: false,
			codeReport: "driver-chat",
            sortBy: 'index',
            sortDesc: true,
            perPage: 10,
			currentPage: 1,
            offsetTable: 0,
			totalRows: 0,
            perPageOptions: [
				{ value: 10, text: 10 },
				{ value: 50, text: 50 },
				{ value: 100, text: 100 },
				{ value: 200, text: 200 },
				{ value: 500, text: 500 }
			],
			filters: {
				startDate: start,
				endDate: end,
                suppliers: [],
                status: [
                    {value:"done",   text:"Realizado", class:"success"},
                    {value:"noShow", text:"No show",   class:"info"}
                ],
                salesChannels: [],
                zones: [],
                trip: 'all',
                withDriver: 'all',
                timeGrouping: 'week'
			},
            driverOpts: [
                {value: 'all', text: 'Todos'},
                {value: 'with_driver', text: 'Con conductor asignado'},
                {value: 'without_driver', text: 'Sin conductor asignado'}
            ],
            groupingOpts: [
                {value: 'week',  text: 'Semana'},
                {value: 'day',   text: 'Dia'},
                {value: 'month', text: 'Mes'}
            ],
            events: [],
            summary: {
                totalRides: 0,
                general: null,
                bySupplier: [],
                byDriver: [],
                byTime: null
            },
            table: {
                body: [],
                fields: [
                    {
                        key: 'serviceNumber',
                        label: 'Servicio',
                        sortable: false,
                        tdClass: 'text-nowrap'
                    },
                    {
                        key: 'tripType',
                        label: 'Viaje',
                        sortable: true
                    },
                    {
                        key: 'supplier',
                        label: 'Proveedor / Canal',
                        sortable: false
                    },
                    {
                        key: 'pickupDatetime',
                        label: 'Fecha Pickup',
                        sortable: true
                    },
                    {
                        key: 'pickup_place',
                        label: 'Pickup',
                        sortable: false
                    },
                    {
                        key: 'dropoff_place',
                        label: 'Dropoff',
                        sortable: false
                    },
                    {
                        key: 'status',
                        label: 'Estado',
                        sortable: true
                    },
                    {
                        key: 'user_driver',
                        label: 'Conductor',
                        sortable: false
                    },
                    /*
                    {
                        key: 'tags',
                        label: 'Tags',
                        sortable: false
                    },
                    */
                    {
                        key: 'status_chat',
                        label: 'Estatus Chat',
                        sortable: false
                    },
                    {
                        key: 'meet_and_greet',
                        label: 'Meet & Greet',
                        sortable: false
                    }
                ]
            },
            serviceSelected: null,
            panels: {
                drivers:{assigned:{value:0,percent:0},notAssigned:{value:0,percent:0}},
                driverAppUse:{finished:{value:0,percent:0},notFinished:{value:0,percent:0}},
                trackingStatus:{}
			},
			loadingPanels:false,
			tabActive:null
        }
    },
    methods: {
        onPageChange(page) {        
            this.offsetTable = (page - 1)  * this.perPage
            this.search();
        },
        search(format = "") {

            this.loading    = true
            this.table.body = []

            api(this)
            .get(`/reports/${this.codeReport}`, {
                params: {
                 filters: {...this.filters, perPage: this.perPage, offset: this.offsetTable},
                    format: format
                }
            })
            .then(res => {
                const data = res.data;
                this.table.body = data.rows
                this.totalRows  = data.totalRows
                this.events     = data
                this.panels     = data.resumeOperation
                // Guardar el summary para los gráficos
                if (data.summary) {
                    this.summary = data.summary
                }
            })
            .catch(error => {
                this.$root.handleRequestError(error);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        updateTable() {
            this.search()
        },
        excel() {
			if (this.loadingExcel) return;

			this.loadingExcel = true;
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters,
						format: "excel"
					},
					responseType: "blob"
				})
				.then(res => {
					this.$root.downloadExcel(res, "driverChat");
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {
					this.loadingExcel = false;
				});
		},
        showMap(service) {
            this.serviceSelected = service
            this.$refs['modal-map-events'].show()
        },
        getDataTrackingStatus(trackingStatusCode, field) {
			if (typeof this.panels.trackingStatus[trackingStatusCode] ==='undefined')
                return 0;
			try {
				return this.panels.trackingStatus[trackingStatusCode][field];
			} catch(err) {
				console.log(err)
			}

			return 0;
		},
        getTagVariant(tagText) {
            const tagVariants = {
                'chat efect': 'success',
                'nc pax': 'warning',
                'nc driver': 'danger',
                'no chat': 'secondary',
                'm&g': 'info',
                'm@p': 'info',
                'ns': 'danger',
                'ver nota': 'dark'
            };
            return tagVariants[tagText.toLowerCase()] || 'light';
        }
    },
    mounted() {
      this.$root.auxVars.loadResourcesOpts({
        vm: this, 
        resourceNames: [
          'salesChannelsOpts',
          'masterZonedAreasOpts',
          'suppliersOpts',
          'transportServiceStatusOpts'
        ]
      })
    },
    computed: {
        filtersClean() {
			return {
				salesChannel: this.filters.salesChannels.map(aux => aux.value),
				supplier: this.filters.suppliers.map(aux => aux.value),
				pickupStartDate: this.filters.startDate,
				pickupEndDate: this.filters.endDate,
				trip: this.filters.trip,
				status: this.filters.status.map(aux => aux.value),
				zones: this.filters.zones,
			};
		},
		trackingStatus(){
			return this.$root.auxVars.transportServiceTrackingStatusOpts
		},
        suppliersOpts() {
            return [
            {
                group: "SELECT ALL",
                options: this.$root.auxVars.suppliersOpts.map((sp) => ({
                value: sp.id,
                text: sp.code
                }))
            }
            ];
        },
        statusOpts() {
            return [
                {
                    group: "SELECT ALL",
                    options: this.$root.auxVars.transportServiceStatusOpts
                }
            ];
        },
        zonesOptions() {
            let aux= [...this.$root.auxVars.masterZonedAreasOpts.map((zam) => ({
                value: zam.id,
                text: zam.name,
                }))];
            return aux;

        },
        channelOpts(){
            let aux= [...this.$root.auxVars.salesChannelsOpts.map((sc) => ({
                value: sc.id,
                text: sc.code,
                }))];
            return aux;
        },
        zonedAreasGroupedOpts(){
            let grouped = [];
            this.$root.auxVars.masterZonedAreasOpts.forEach((ele)=>{
                let item = {
                    zonedArea:ele.name,
                    zones:ele.zones.map((aux)=>({value:aux.id,text:aux.name,zonedAreaName:ele.name}))
                };
                grouped.push(item)
            })
            return grouped
		},
        tripOpts() {
            let aux = [...this.$root.auxVars.tripOpts];
            aux.unshift({ value: "all", text: "Todos" });
            return aux;
        },
        statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
        variantStatus() {
            return {
                "pending" : "secondary",
                "active" : "default",
                "noShow" : "info",
                "noProvided": "warning",
                "canceled": "danger",
                "done": "success",
                "partialCancellation": "partialCancellation"
            }
        },
        variantTrackingStatus() {
            return {
                "finished": "success",
                "noShow": "warning",
                "pending": "secondary",
                "onWayToPickup": "info",
                "atPickup": "primary",
                "onWayToDropoff": "info"
            }
        },
        generalStatsFields() {
            return [
                { key: 'label', label: 'Categoría' },
                { key: 'count', label: 'Cantidad' },
                { key: 'percentage', label: 'Porcentaje' }
            ]
        },
        generalStatsTable() {
            if (!this.summary.general) return [];
            const g = this.summary.general;
            return [
                { label: 'Chat Efectivo', count: g.chatEfect?.count || 0, percentage: g.chatEfect?.percentage || 0, variant: 'success' },
                { label: 'NC Pax', count: g.ncPax?.count || 0, percentage: g.ncPax?.percentage || 0, variant: 'warning' },
                { label: 'NC Driver', count: g.ncDriver?.count || 0, percentage: g.ncDriver?.percentage || 0, variant: 'danger' },
                { label: 'No Chat', count: g.noChat?.count || 0, percentage: g.noChat?.percentage || 0, variant: 'secondary' }
            ];
        },
        generalPieChartOptions() {
            if (!this.summary.general) return {};
            const g = this.summary.general;
            return {
                chart: { type: 'pie', height: 300 },
                title: { text: '' },
                tooltip: {
                    pointFormat: '<b>{point.y}</b> ({point.percentage:.1f}%)'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.percentage:.1f}%'
                        },
                        showInLegend: true
                    }
                },
                colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                series: [{
                    name: 'Rides',
                    data: [
                        { name: 'Chat Efectivo', y: g.chatEfect?.count || 0 },
                        { name: 'NC Pax', y: g.ncPax?.count || 0 },
                        { name: 'NC Driver', y: g.ncDriver?.count || 0 },
                        { name: 'No Chat', y: g.noChat?.count || 0 }
                    ]
                }]
            };
        },
        supplierChartOptions() {
            if (!this.summary.bySupplier || this.summary.bySupplier.length === 0) return {};
            const suppliers = [...this.summary.bySupplier]
                .sort((a, b) => b.stats.totalRides - a.stats.totalRides);

            return {
                chart: { type: 'bar', height: Math.max(400, suppliers.length * 40) },
                title: { text: '' },
                xAxis: {
                    categories: suppliers.map(s => s.supplierName),
                    title: { text: null }
                },
                yAxis: {
                    min: 0,
                    title: { text: 'Cantidad de Rides' },
                    stackLabels: { enabled: true }
                },
                legend: { reversed: true },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y} ({point.percentage:.1f}%)<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            format: '{point.y}'
                        }
                    }
                },
                colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                series: [
                    {
                        name: 'Chat Efectivo',
                        data: suppliers.map(s => s.stats.chatEfect?.count || 0)
                    },
                    {
                        name: 'NC Pax',
                        data: suppliers.map(s => s.stats.ncPax?.count || 0)
                    },
                    {
                        name: 'NC Driver',
                        data: suppliers.map(s => s.stats.ncDriver?.count || 0)
                    },
                    {
                        name: 'No Chat',
                        data: suppliers.map(s => s.stats.noChat?.count || 0)
                    }
                ]
            };
        },
        driverChartOptions() {
            if (!this.summary.byDriver || this.summary.byDriver.length === 0) return {};
            // Ordenar por total rides y tomar top 20
            const drivers = [...this.summary.byDriver]
                .sort((a, b) => b.stats.totalRides - a.stats.totalRides)
                .slice(0, 20);

            return {
                chart: { type: 'bar', height: Math.max(400, drivers.length * 35) },
                title: { text: '' },
                xAxis: {
                    categories: drivers.map(d => `${d.driverName} ${d.tia ? '(TIA)' : ''} - ${d.supplierName || ''}`),
                    title: { text: null }
                },
                yAxis: {
                    min: 0,
                    title: { text: 'Cantidad de Rides' },
                    stackLabels: { enabled: true }
                },
                legend: { reversed: true },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y} ({point.percentage:.1f}%)<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: false
                        }
                    }
                },
                colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                series: [
                    {
                        name: 'Chat Efectivo',
                        data: drivers.map(d => d.stats.chatEfect?.count || 0)
                    },
                    {
                        name: 'NC Pax',
                        data: drivers.map(d => d.stats.ncPax?.count || 0)
                    },
                    {
                        name: 'NC Driver',
                        data: drivers.map(d => d.stats.ncDriver?.count || 0)
                    },
                    {
                        name: 'No Chat',
                        data: drivers.map(d => d.stats.noChat?.count || 0)
                    }
                ]
            };
        },
        worstDriversChartOptions() {
            if (!this.summary.byDriver || this.summary.byDriver.length === 0) return {};
            // Ordenar por mayor porcentaje de (no chat + nc driver) y tomar top 20
            const drivers = [...this.summary.byDriver]
                .filter(d => d.stats.totalRides >= 5) // Filtrar conductores con al menos 5 rides
                .sort((a, b) => {
                    const aWorst = (a.stats.noChat?.percentage || 0) + (a.stats.ncDriver?.percentage || 0);
                    const bWorst = (b.stats.noChat?.percentage || 0) + (b.stats.ncDriver?.percentage || 0);
                    return bWorst - aWorst;
                })
                .slice(0, 20);

            if (drivers.length === 0) return {};

            return {
                chart: { type: 'bar', height: Math.max(400, drivers.length * 35) },
                title: { text: '' },
                xAxis: {
                    categories: drivers.map(d => `${d.driverName} ${d.tia ? '(TIA)' : ''} - ${d.supplierName || ''}`),
                    title: { text: null }
                },
                yAxis: {
                    min: 0,
                    title: { text: 'Cantidad de Rides' },
                    stackLabels: { enabled: true }
                },
                legend: { reversed: true },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y} ({point.percentage:.1f}%)<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: false
                        }
                    }
                },
                colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                series: [
                    {
                        name: 'Chat Efectivo',
                        data: drivers.map(d => d.stats.chatEfect?.count || 0)
                    },
                    {
                        name: 'NC Pax',
                        data: drivers.map(d => d.stats.ncPax?.count || 0)
                    },
                    {
                        name: 'NC Driver',
                        data: drivers.map(d => d.stats.ncDriver?.count || 0)
                    },
                    {
                        name: 'No Chat',
                        data: drivers.map(d => d.stats.noChat?.count || 0)
                    }
                ]
            };
        },
        timeLineChartOptions() {
            if (!this.summary.byTime || !this.summary.byTime.data || this.summary.byTime.data.length === 0) return {};

            const timeData = this.summary.byTime.data;
            const grouping = this.summary.byTime.grouping || 'week';

            return {
                chart: { type: 'line', height: 400 },
                title: { text: '' },
                xAxis: {
                    categories: timeData.map(t => t.periodLabel || t.period),
                    title: { text: grouping === 'week' ? 'Semana' : 'Periodo' },
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: { text: 'Cantidad de Rides' }
                },
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                },
                tooltip: {
                    shared: true,
                    crosshairs: true,
                    formatter: function() {
                        let html = '<b>' + this.x + '</b><br/>';
                        this.points.forEach(point => {
                            const pct = point.point.pct !== undefined ? point.point.pct : '';
                            html += '<span style="color:' + point.series.color + '">\u25CF</span> ' +
                                    point.series.name + ': <b>' + point.y + '</b>' +
                                    (pct !== '' ? ' (' + pct + '%)' : '') + '<br/>';
                        });
                        return html;
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        },
                        marker: {
                            enabled: true,
                            radius: 4
                        }
                    }
                },
                colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d', '#007bff'],
                series: [
                    {
                        name: 'Chat Efectivo',
                        data: timeData.map(t => ({
                            y: t.stats?.chatEfect?.count || 0,
                            pct: t.stats?.chatEfect?.percentage || 0
                        }))
                    },
                    {
                        name: 'NC Pax',
                        data: timeData.map(t => ({
                            y: t.stats?.ncPax?.count || 0,
                            pct: t.stats?.ncPax?.percentage || 0
                        }))
                    },
                    {
                        name: 'NC Driver',
                        data: timeData.map(t => ({
                            y: t.stats?.ncDriver?.count || 0,
                            pct: t.stats?.ncDriver?.percentage || 0
                        }))
                    },
                    {
                        name: 'No Chat',
                        data: timeData.map(t => ({
                            y: t.stats?.noChat?.count || 0,
                            pct: t.stats?.noChat?.percentage || 0
                        }))
                    },
                    {
                        name: 'Total Rides',
                        data: timeData.map(t => ({
                            y: t.stats?.totalRides || 0
                        })),
                        dashStyle: 'ShortDash'
                    }
                ]
            };
        },
        offset() {
			return (this.currentPage - 1) * this.perPage;
		},
        rowsFrom() {
			return this.offset + 1;
		},
		rowsTo() {
			return Math.min(this.offset + this.perPage, this.totalRows);
		},
        rowsMessage() {
			return (
				"Mostrando " +
				this.rowsFrom +
				" a " +
				this.rowsTo +
				" registros de " +
				this.totalRows
			);
		}
    }
}

</script>

<style scoped>
    .active {
        color: cornflowerblue;
    }
    #perPageSelector {
        width: 80px;
    }
</style>